import { combineReducers } from 'redux'
import auth from '../../ducks/auth'
import modal from '../../ducks/modal'
import formState from '../../ducks/formState'
import serviceWorker from '../../ducks/serviceWorker'
import featureFlags from '../../ducks/featureFlags'
import internalCampaigns from '../../ducks/internalCampaigns'

const RootReducer = combineReducers({
  auth,
  modal,
  serviceWorker,
  formState,
  featureFlags,
  internalCampaigns,
})

export default RootReducer
